import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "上传图标", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_loading_outlined = _resolveComponent("loading-outlined")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_drawer, {
      title: _ctx.productId ? '产品线编辑' : '产品线新增',
      width: 720,
      visible: _ctx.visible,
      "footer-style": { textAlign: 'right' },
      onClose: _ctx.onClose
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          style: {"margin-right":"8px"},
          onClick: _ctx.onClose
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }, 8, ["onClick"]),
        (!_ctx.disabled)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              loading: _ctx.isLoading,
              type: "primary",
              onClick: _ctx.onSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode("提交")
              ]),
              _: 1
            }, 8, ["loading", "onClick"]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_spin, {
          tip: "加载中...",
          spinning: _ctx.isLoading
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["check-form", { disabled: _ctx.disabled }])
            }, [
              _createVNode(_component_a_form, {
                ref: "formRef",
                model: _ctx.form,
                rules: _ctx.rules,
                layout: "vertical"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, { gutter: 16 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "产品名称",
                            name: "productName"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: _ctx.form.productName,
                                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.productName) = $event))
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, { gutter: 16 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "是否启用",
                            name: "active"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_switch, {
                                checked: _ctx.form.active,
                                "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.active) = $event)),
                                "checked-children": "启用",
                                "un-checked-children": "禁用"
                              }, null, 8, ["checked"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "负责人",
                            name: "productOwner"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: _ctx.form.productOwner,
                                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.productOwner) = $event))
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, { gutter: 16 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "图标",
                            name: "active"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_upload, {
                                fileList: _ctx.uploadList,
                                "onUpdate:fileList": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.uploadList) = $event)),
                                name: "icon",
                                class: "avatar-uploader",
                                "list-type": "picture-card",
                                accept: ".jpg,.jpeg,.png,.bmp,.gif",
                                "max-count": 1,
                                "before-upload": _ctx.beforeUpload,
                                onChange: _ctx.handleChange
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.state.icon)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: _ctx.state.icon,
                                        alt: "avatar",
                                        style: {"width":"100%","height":"100%"}
                                      }, null, 8, _hoisted_1))
                                    : (!_ctx.uploadList.length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                          (_ctx.isUploadLoading)
                                            ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                                            : (_openBlock(), _createBlock(_component_plus_outlined, { key: 1 })),
                                          _hoisted_3
                                        ]))
                                      : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["fileList", "before-upload", "onChange"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, { gutter: 16 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "描述",
                            name: "description"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_textarea, {
                                value: _ctx.form.description,
                                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.description) = $event)),
                                rows: 3
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ], 2)
          ]),
          _: 1
        }, 8, ["spinning"])
      ]),
      _: 1
    }, 8, ["title", "visible", "onClose"])
  ]))
}